
const columns = [
    {
        title: "تاریخ ثبت",
        dataIndex: "createdAt",
        key: "createdAt",
        width: 130,
        sorter: true,
      },
  {
    title: "تاریخ وقوع",
    dataIndex: "occurrenceAt",
    key: "occurrenceAt",
    width: 130,
    sorter: true,
  },
  {
    title: "مبلغ (ریال)",
    dataIndex: "amount",
    key: "amount",
    width: 140,
    sorter:true
  },
  {
    title: "توضیحات",
    dataIndex: "description",
    key: "description",
    ellipsis: true
  },
  {
    title: "جزییات",
    dataIndex: "details",
    key: "details",
    width: 140,
  },
];

export default columns;
